<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="correctTranslationDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>

          <v-col v-if="correctTranslationDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.correctTranslationDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.correctTranslationDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { CorrectTranslationStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: { ...bankDetails },
    correctTranslationDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      correctTranslationDetails: {
        note: {
          required: requiredIf(
            () => this.correctTranslationDetails.hasPrivilege
          ),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const SCTD = ServicesModule.statement.correctTranslationDetails;

      if (SABD) {
        this.accountBankDetails = {
          ...this.accountBankDetails,
          ...SABD,
        };
      }

      if (SCTD) {
        this.correctTranslationDetails = {
          ...this.correctTranslationDetails,
          ...SCTD,
        };
      }
    },

    assemblyModel() {
      if (!this.correctTranslationDetails.hasPrivilege) {
        this.correctTranslationDetails.note = null;
      }

      return {
        accountBankDetails: {
          ...this.accountBankDetails,
        },
        correctTranslationDetails: {
          ...this.correctTranslationDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: CorrectTranslationStep.BANK_DETAILS,
      });
    },
  },
};
</script>
